module.exports = __webpack_public_path__ + "static/media/book mark 6.009f731f.jpg";